import React from "react";
import { withStyles } from "@material-ui/core/styles";

const NavSpacer = props => <div className={props.classes.root} />;

export default withStyles({ root: { flexGrow: 1 } }, { name: "LcNavSpacer" })(
  NavSpacer
);
